import { defineComponent as _defineComponent } from 'vue'
import CategoryProductCategoryFiltering from './CategoryProductCategoryFiltering.vue';
import CategoryProductFacetFiltering from './CategoryProductFacetFiltering.vue';
import { UrlQueryKey } from '@/router/urlHelper';
import { computed, onMounted, ref, useSlots, watch } from 'vue';
import { useRoute } from 'vue-router/composables';
import { watchRelativeUrl } from '@/core/route.service';
import Http from '@/core/http/http.service';
import queryParamsService from '@/core/query-params.service';
import FacetSearchViewModel = Vertica.LouisPoulsen.Application.Search.ViewModels.FacetSearch.FacetSearchViewModel;

interface SelectedParameters {
    selectedFacets: { [key: string]: string[] },
    selectedCategoryCode: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryPageB2B',
  props: {
    headline: null,
    categoryCode: null,
    visibleCategories: null,
    visibleFacets: null,
    useFacetGroups: { type: Boolean, default: false },
    removeFacetGroups: { type: Boolean, default: false },
    showTallProductImages: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { headline: string, categoryCode: string, visibleCategories: CategoryFilterViewObject[], visibleFacets: FacetViewObject[], useFacetGroups: boolean, removeFacetGroups: boolean, showTallProductImages: boolean }



const slots = useSlots();
const hasInitialProductGrid = computed<boolean>(() => slots['product-grid'] !== undefined);

const availableFacets = ref<{ [facetId: string] : FacetValueViewObject[] }>({});
const searchedProducts = ref<ProductTileViewModel[]>([]);
const pending = ref<boolean>(false);
const total = ref<number>(0);
const preventRouteUpdates = ref<boolean>(false);

const selectedFacets = ref<{ [key: string]: string[] }>();
const selectedCategoryCode = ref<string>();

const route = useRoute();

function getFacets() {
    const result: { [key: string]: string[] } = {};
    Object
        .keys(route.query)
        .forEach(key => {
            result[key] = (route.query[key] instanceof Array ? route.query[key] : [route.query[key]]) as string[];
        });
    return result;
}

function getCategoryCode() {
    const queryParam = queryParamsService.getParam(UrlQueryKey.categoryCodeKey);
    return hasCategories.value && queryParam ? queryParam : props.categoryCode;
}

const hasCategories = computed<boolean>(() => props.visibleCategories.length > 0);
const hasFacets = computed<boolean>(() => props.visibleFacets.length > 0);
const enableSearch = computed<boolean>(() => hasCategories.value || hasFacets.value);

const parameters = computed<SelectedParameters>(() => {
    return {
        selectedFacets: selectedFacets.value,
        selectedCategoryCode: selectedCategoryCode.value
    };
});

onMounted(() => {
    selectedFacets.value = getFacets();
    selectedCategoryCode.value = getCategoryCode();
});

async function getSearchByFacets(parameters?: SelectedParameters, oldParameters?: SelectedParameters): Promise<void> {
    if (!parameters) return;
    if (!enableSearch.value || preventRouteUpdates.value) {
        return;
    }
    pending.value = true;
    const request = {
        CategoryCode: parameters.selectedCategoryCode,
        PageSize: 10000,
        LastFacet: getLastFacet()
    };

    Object.keys(selectedFacets.value).forEach(facetKey => {
        request[facetKey] = selectedFacets.value[facetKey].join('|');
    });
    if (preventRouteUpdates.value) return;
    Http.get<FacetSearchViewModel>('search/facetsearch', request).then((response) => {
        availableFacets.value = response.facets.reduce(
            (prev: { [facetId: string] : FacetValueViewObject[] }, value: FacetViewObject) => {
                prev[value.facetId] = value.values;
                return prev;
            },
            {});

        total.value = response.total;
        searchedProducts.value = response.products;
        pending.value = false;
    });
}

function getLastFacet(): string | undefined {
    return queryParamsService.getParam(UrlQueryKey.lastFacetKey);
}

watch(parameters, getSearchByFacets, { deep: true });

function routeChanged(route: RelativeUrl, oldRoute: RelativeUrl) {
    preventRouteUpdates.value = route !== undefined && oldRoute !== undefined && route.path !== oldRoute.path;
    if (route && oldRoute && route.path === oldRoute.path) {
        selectedFacets.value = getFacets();
        selectedCategoryCode.value = getCategoryCode();
    }
}

watchRelativeUrl(routeChanged);


return { __sfc: true,props, slots, hasInitialProductGrid, availableFacets, searchedProducts, pending, total, preventRouteUpdates, selectedFacets, selectedCategoryCode, route, getFacets, getCategoryCode, hasCategories, hasFacets, enableSearch, parameters, getSearchByFacets, getLastFacet, routeChanged, CategoryProductCategoryFiltering, CategoryProductFacetFiltering }
}

})